import React, { PureComponent } from 'react';
import classNames from 'classnames';
import _omit from 'lodash.omit';

class SelectField extends PureComponent {

  handleChange = (e) => {
    const { onChange } = this.props;
    const value = typeof(e) === 'string' ? e : e.target.value;
    if (value === 'Select') {
      return onChange('');
    }
    onChange(value);
  }

  handleKeyDown = (value) => {
    return this.props.onKeyDown && ((e) => {
      const ENTER_KEY = 13;
      if (e.keyCode === ENTER_KEY) {
        this.props.onKeyDown(value);
      }
    });
  }

  render() {
    const {
      className,
      selectedValue,
      errorMsg,
      tabIndex,
      options,
      htmlFor,
      labelClassName,
      labelText,
      defaultValue,
      ...rest
    } = this.props;

    const DEFAULT_VALUE = 'Select';
    const selectOptions = [{ text: DEFAULT_VALUE, value: DEFAULT_VALUE }, ...options ];
    const selectProps = _omit(rest, 'onKeyDown');
    const selectClasses = classNames('select-field-input',
    {
      'select-field-input--default': !selectedValue || !defaultValue || selectedValue === DEFAULT_VALUE,
      'input-helper-select-wrapper--error': errorMsg
    });

    return <div className={classNames('select-field', className)}>
      <label id={htmlFor} className={classNames(labelClassName, { 'section-label--error': errorMsg })}>
        {labelText}
      </label>
      {
        options && options.length > 1 &&
        <>
          <select
            data-test-id="practice-type-select"
            {...selectProps}
            onBlur={this.handleChange}
            value={selectedValue}
            defaultValue={defaultValue || DEFAULT_VALUE}
            onChange={this.handleChange}
            className={selectClasses}>
            { selectOptions.map(({text, value}) => (<option key={`select_${value}`} value={value}>{text}</option>))}
          </select>
          <div data-test-id="practice-type-pill" tabIndex={tabIndex} className={classNames('select-pill-list', { 'select-pill-list--error': errorMsg })}>
            { this.props.options.map(({text, className, value}) => (
            <span
              data-test-id={`${value?.toLowerCase().replaceAll(" ","-")}-pill-item`}
              tabIndex={tabIndex}
              className={classNames('pill', className || '', { 'pill--selected': value === selectedValue })}
              onKeyDown={this.handleKeyDown(value)}
              onClick={() => this.handleChange(value)} key={`select_${value}`}
              value={value}>
                {text}
              </span>))}
          </div>
          { errorMsg && <div className={'field-error-msg'}>{errorMsg}</div>}
        </>
      }
    </div>;
  }
}

SelectField.defaultProps = {
  options: [],
  tabIndex: 0
};

export default SelectField;

